<template>
  <div class="p-4 flex justify-between">
    <div class="flex items-center">
      <button
        class="ml-2 inline-flex items-center px-2 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        @click="toggleMute"
      >
        <volume-up v-if="call.muted" />
        <volume-off v-if="!call.muted" />
      </button>
      <div class="px-2 text-sm truncate">
        <span class="font-medium text-indigo-600 ">{{ call.phoneNumber }}</span><br>
        <span class="italic"><call-timer :enabled="call.status === 'IN_PROGRESS'" @update-timer="updateSecondsInCall" /></span>
      </div>
    </div>
    <div>
      <button
        class="ml-2 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        :class="{'bg-indigo-600 hover:bg-indigo-700': canHangUp, 'bg-gray-600 cursor-not-allowed': !canHangUp}"
        :disabled="!canHangUp"
        @click="disconnectCall"
      >
        Hang up
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    call: {
      type: Object,
      required: true
    }
  },
  setup () {
    const callConsole = useCallConsoleStore()
    return { callConsole }
  },
  data () {
    return {
      secondsInCall: 0
    }
  },
  computed: {
    canHangUp () {
      return this.secondsInCall >= 5
    }
  },
  methods: {
    disconnectCall () {
      this.callConsole.disconnectCall({ id: this.call.id })
    },
    toggleMute () {
      this.callConsole.toggleMute({ id: this.call.id })
    },
    updateSecondsInCall (seconds) {
      this.secondsInCall = seconds
    }
  }
}
</script>
